import styled from "@emotion/styled";

export const FooterGrid = styled.div`
display:grid;
width: 100%;

grid-template-columns:repeat(4, 1fr);
gap:20px;

@media(max-width: 780px){
display: grid;
grid-template-columns: repeat(2, 1fr);
}
`;